import { createContext, ReactChild, ReactFragment, ReactPortal } from 'react'
import EventManager from '../EventsProvider/EventsProvider'
import ScenesProvider from '../ScenesProvider/SceneProvider'
import TweenProvider from '../TweensProvider/TweensProvider'

export type GameContext = {
  events: typeof EventManager
}

const initialGameContext = {
  events: EventManager,
}

export const GameContext = createContext<GameContext>(initialGameContext)

type GameProviderProps = {
  children: ReactChild | ReactFragment | ReactPortal
}

const GameProvider = ({ children }: GameProviderProps) => {
  const events = EventManager

  return (
    <GameContext.Provider value={{ events }}>
      <TweenProvider>
        <ScenesProvider>{children}</ScenesProvider>
      </TweenProvider>
    </GameContext.Provider>
  )
}

export default GameProvider
